import { config } from 'app/config'

import { AvailableConnection } from '../types'

type SupportedConnectionConfig<C = AvailableConnection> = C extends AvailableConnection
  ? Omit<C, 'capabilities' | 'category'>
  : never

export const supportedConnectionConfigs: SupportedConnectionConfig[] = [
  {
    authConfig: {
      params: {
        client_id: config.amazonClientId,
        response_type: 'code',
        scope: ['advertising::campaign_management', 'advertising::audiences'].join(' '),
      },
      // Login with Amazon is region bound, we only support the european region
      url: 'https://eu.account.amazon.com/ap/oa',
    },
    config: {
      amcInstanceId: '',
    },
    multiStepSetup: false,
    name: 'amazon',
    readonly: false,
    // the amc instance is not configurable for now
    readonlyConfig: ['amcInstanceId'],
  },
  {
    authConfig: {
      params: {
        auth_type: 'rerequest',
        client_id: config.facebookClientId,
        display: 'popup',
        response_type: 'code',
        scope: ['ads_read', 'ads_management', 'email'].join(','),
      },
      url: 'https://www.facebook.com/v13.0/dialog/oauth',
    },
    config: {
      accounts: [],
      pixelId: '',
      adId: '',
    },
    multiStepSetup: true,
    name: 'facebook',
    readonly: false,
    readonlyConfig: ['pixelId'],
  },
  {
    config: {
      project: '',
    },
    multiStepSetup: false,
    name: 'googleBigquery',
    readonly: true,
    readonlyConfig: [],
  },
  {
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.analyticsClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope: 'https://www.googleapis.com/auth/analytics.edit email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      propertyId: '',
      measurementId: '',
      apiSecret: '',
    },
    multiStepSetup: true,
    name: 'googleAnalytics',
    readonly: false,
    readonlyConfig: ['propertyId'],
  },
  {
    config: {
      trackingUrl: '',
    },
    multiStepSetup: false,
    name: 'innkeepr',
    readonly: false,
    readonlyConfig: [],
  },
  {
    config: { shops: [] },
    multiStepSetup: false,
    name: 'shopify',
    readonly: false,
    readonlyConfig: [],
  },
  {
    config: {
      shopbaseUrl: '',
      apiKey: '',
      apiSecret: '',
    },
    multiStepSetup: false,
    name: 'woocommerce',
    readonly: false,
    readonlyConfig: [],
  },
  {
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.adwordsClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope:
          'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/datamanager email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      accounts: [],
      campaignId: '',
    },
    multiStepSetup: true,
    name: 'googleAdwords',
    readonly: false,
    readonlyConfig: [],
  },
  {
    authConfig: {
      params: {
        app_id: config.tiktokAppId,
      },
      url: `https://ads.tiktok.com/marketing_api/auth`,
    },
    config: {
      adAccountIds: '',
      adId: 'ttm',
      advertisers: [],
    },
    multiStepSetup: false,
    name: 'tiktok',
    readonly: false,
    readonlyConfig: [],
  },
  {
    authConfig: {
      params: {
        response_type: 'code',
        client_id: config.criteoClientId,
        scope: 'campaign.read',
      },
      url: `https://consent.criteo.com/request`,
    },
    config: {
      advertisers: [],
      adSetId: '',
      gumCallerId: '',
    },
    multiStepSetup: true,
    name: 'criteo',
    readonly: false,
    readonlyConfig: [],
  },
  {
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.dv360ClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope: 'https://www.googleapis.com/auth/display-video email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      advertisers: [],
      adGroupId: '',
    },
    multiStepSetup: true,
    name: 'dv360',
    readonly: false,
    readonlyConfig: [],
  },
]
